<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">提现记录</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record sign-record1" ref="content">
      <div class="list">
        <div class="item" v-for="(val, index) in info" :key="index">
          <!--<div class="data">{{ item.time }}</div>-->
          <div class="listn" >
            <div class="itemn acea-row row-between-wrapper">
              <div>
                  <div class="name line1" style="color:red;" v-if="val.status == -1">{{ val.status_name }}</div>
                <div class="name line1"  v-if="val.status == 0">{{ val.status_name }}</div>
                  <div class="name line1" style="color:#16ac57;" v-if="val.status == 1">{{ val.status_name }}</div>
                <div class="name line1">手续费：{{val.all_fee_money}} 到账金额：{{val.get_money}}</div>
                <div class="name line1">{{val.bank_address}} 尾号：{{val.bank_code_last}}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="num " style="color:#282828">
                {{ val.extract_price }}
              </div>
              <div style="clear:both;"></div>
              <div style="display:block;width:100%;" v-if="val.fail_msg">
                备注：{{ val.fail_msg }}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .sign-record .list .item .listn .itemn .num {
    width: 3rem;
    text-align: right;
  }
</style>
<script>
import { getBank,getExtractList } from "../../../api/user";
import Loading from "@components/Loading";

export default {
  name: "CashRecord",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      commission: 0,
      where: {
        page: 1,
        limit: 20
      },
      types: 4,
      loaded: false,
      loading: false
    };
  },
    watch: {
        $route(n) {
            if (n.name == "CashRecord") {
                this.where.page = 1;
                this.loaded = false;
                this.loading = false;
                this.info = [];
                this.getBank();
                this.getIndex();
            }
        }
    },
  mounted: function() {
    this.getBank();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getExtractList(that.where).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getBank: function() {
      let that = this;
      getBank().then(
        res => {
          that.commission = res.data.extract_money;
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
